<template>
	<div class="header__container">
				<div class="header" style="position: relative" v-html="header">
				</div>
				<div class="subHeader" style="position: relative" v-html="subHeader">
				</div>
				<div class="text" style="position: relative" v-html="bodytext">
				</div>
			</div>
</template>

<script>

	import { url} from '../../const/base';

	export default {
		props:[
			'header',
			'subHeader',
			'bodytext'
		],

		components:{
		},

		mounted(){
			
		},
		data(){
			return {
				baseUrl : url
			}
		},
		methods:{
			
		},
		computed:{
			
		},

	}
</script>


// WEBPACK FOOTER //
// src/components/minigames/HeaderBlock.vue